import axios from 'axios'

let instance = axios.create({
    baseURL: 'https://api.unitedquartzs.com',
    timeout: 12000
})

instance.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export default function(method, url, data = null) {
    method = method.toLowerCase()
    if (method === 'post') {
        return instance.post(url, data)
    } else if (method === 'get') {
        return instance.get(url, { params: data })
    } else if (method === 'delete') {
        return instance.delete(url, { params: data })
    } else if (method === 'put') {
        return instance.put(url, data)
    } else {
        return false
    }
}
